export default __webpack_public_path__ + "static/app-store-badge-d0d163d4d0fad9c91f53131cfc443f2f.svg";